import React from 'react';
import { Button } from '@material-ui/core';
import { AuthRoles, readableSchemeTypes, Roles, SchemeTypes } from 'config';
import {
  Control,
  useForm,
  DeepMap,
  FieldError,
  useFormContext,
} from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppTextField,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import { useDispatch } from 'react-redux';
import AdminDaashboardActions from '../../../../redux/reducers/admin_dashboard_reducer/actions';

interface FormFields {
  schemeType: string | null;
  periodLength: string | null;
}

interface IProps {
  schemeType: string | null;
  periodLength: string | null;
  role: Roles;
  filters: any;
}

const FilterForm = (props: IProps) => {
  const defaultValues = {
    schemeType: props.schemeType,
    periodLength: props.periodLength ? props.periodLength : '3',
  };

  const { control, errors, watch, setValue, handleSubmit } =
    useForm<FormFields>({
      defaultValues: defaultValues,
    });

  const onSubmit = (data: any) => {
    let queryString = '';
    if (data.periodLength) queryString = `?periodLength=${data.periodLength}`;

    if (data.periodLength) queryString += `&schemeType=${data.schemeType}`;
    else {
      if (data.schemeType) queryString = `?schemeType=${data.schemeType}`;
    }

    history.push(NavigationConfig.dashboardPage().path + queryString);
  };

  const schemeTypeValue = watch('schemeType');
  const periodLengthValue = watch('periodLength');

  const dispatch = useDispatch();
  const history = useHistory();

  // React.useEffect(() => {
  //   if (schemeTypeValue || periodLengthValue) {
  //     if (schemeTypeValue && periodLengthValue) {
  //       console.log(schemeTypeValue, periodLengthValue);
  //       dispatch(
  //         AdminDaashboardActions.fetchAdminDashboardDataAction({
  //           schemeType: schemeTypeValue,
  //           periodLength: periodLengthValue,
  //         })
  //       );
  //     } else if (schemeTypeValue) {
  //       dispatch(
  //         AdminDaashboardActions.fetchAdminDashboardDataAction({
  //           schemeType: schemeTypeValue,
  //         })
  //       );
  //     } else if (periodLengthValue) {
  //       dispatch(
  //         AdminDaashboardActions.fetchAdminDashboardDataAction({
  //           periodLength: periodLengthValue,
  //           onSuccess: () => {
  //             if (
  //               props.filters &&
  //               props.filters.periodLength &&
  //               props.filters.periodLength !== periodLengthValue
  //             ) {
  //               console.log(schemeTypeValue, periodLengthValue, props.filters);
  //               // history.push(
  //               //   NavigationConfig.dashboardPage().path +
  //               //     `?periodLength=${periodLengthValue}`
  //               // );
  //             }
  //           },
  //         })
  //       );

  //       // if (props.periodLength !== periodLengthValue) {
  //       //   history.push(
  //       //     NavigationConfig.dashboardPage().path +
  //       //       `?periodLength=${periodLengthValue}`
  //       //   );
  //       // }
  //     }
  //     // let queryString = '';
  //     // if (periodLengthValue) queryString = `?periodLength=${periodLengthValue}`;

  //     // if (periodLengthValue && schemeTypeValue) {
  //     //   queryString += `&schemeType=${schemeTypeValue}`;
  //     // } else if (schemeTypeValue) {
  //     //   queryString = `?schemeType=${schemeTypeValue}`;
  //     // }

  //     // console.log(schemeTypeValue, periodLengthValue);
  //     // history.push(NavigationConfig.dashboardPage().path + queryString);
  //     // dispatch(AdminDaashboardActions.fetchAdminDashboardDataAction({
  //     //   schemeType: schemeTypeValue,
  //     //   periodLength: periodLengthValue
  //     // }))
  //   }
  // }, [schemeTypeValue, periodLengthValue, dispatch]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        justify="flex-start"
        elements={
          [
            {
              element: renderSchemeTypeField(errors, control),
              size: 5,
              id: 'schemeType',
            },
            {
              element: renderPeriodLengthField(errors, control),
              size: 5,
              id: 'periodLength',
            },
            {
              element: (
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{
                    marginTop: '1.2rem',
                    marginRight: '0.25rem',
                  }}
                >
                  <TranslatedText textMap={Translations.search} />
                </Button>
              ),
              size: 2,
              id: 'search',
            },
          ] as any
        }
      />
    </form>
  );
};

const renderSchemeTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const schemeTypes = ['MOSS', 'VOES', 'IMPORT'];
  let select_options = [];
  select_options.push({
    id: '',
    label: Translations.schemeType.English,
  });
  for (let schemeType of schemeTypes) {
    select_options.push({
      id: schemeType,
      label: _.get(readableSchemeTypes, schemeType),
    });
  }
  if (control.mode.isOnChange) {
    console.log('Value has changed');
  }

  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.schemeType} />}
      id="schemeType"
      name="schemeType"
      error={'schemeType' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.schemeType && errors.schemeType.message}
      style={{
        marginTop: '0.6rem',
        marginRight: '0.25rem',
      }}
    />
  );
};

const renderPeriodLengthField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const years = ['1', '2', '3'];
  let select_options = [];
  for (let year of years) {
    select_options.push({
      id: year,
      label: year + ` Year(s)`,
    });
  }
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.periodLength} />}
      id="periodLength"
      name="periodLength"
      error={'periodLength' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.periodLength && errors.periodLength.message}
      style={{
        marginTop: '0.6rem',
        marginRight: '0.25rem',
      }}
    />
  );
};

export default FilterForm;
